import { gql } from '@apollo/client';

export const REMOVE_RELATED_INCIDENT = gql`
  mutation removeRelatedIncident($input: RemoveRelatedIncidentInput!) {
    removeRelatedIncident(input: $input) {
      errors
    }
  }
`

//Example input:
// {
//   "input": {
//     "incidentId": ID,
//     "originatorId": ID
//   }
// }

